<template>
  <textarea class="text-area" :value="value" @input="updateValue"></textarea>
</template>

<script>

export default {
  name: 'TextArea',
  props: {
    value: {
      type: String,
      require: false,
      default: '',
    },
  },
  methods: {
    updateValue(e) {
      this.$emit('input', e.target.value);
    },
  },
};
</script>

<style lang="scss">
  .text-area {
    box-sizing: border-box;
    width: 100%;
    height: 200px;
    padding: 10px 20px;
    font-size: 14px;
    line-height: 18px;
    border: 1px solid var(--border-common);
    outline: none;
    resize: none;
    border-radius: 4px;
    background: transparent;
  }
</style>
